<div class="search-tips" *ngIf="visible">
    <div class="title">{{title}}</div>
    <div class="tips">
        <div class="tip" *ngFor="let tip of tips">
            <span class="tip-label">{{tip.label}}</span> <span class="tip-text">{{tip.text}}</span>
        </div>
    </div>
    <div class="comments" *ngFor="let comment of comments">
        <p>{{comment}}</p>
    </div>
</div>